import React, { useEffect, useState } from 'react'
import config from '../../config.json'
import { get } from '../helpers/Api'

import PreviewGraphic from '../previews/PreviewGraphic'

import { Skeleton } from '@nextui-org/react'
import Link from '../common/util/input/Link'

const CollectionRankingsHome = (props) => {
    const [collectionVolumes, setCollectionVolumes] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    const getCollectionVolume = async () => {
        return get(
            `top-collections/1?limit=${config.landingpage.elementcount}`,
            'v3',
        )
    }

    const parseCollectionVolume = (res) => {
        setCollectionVolumes(res)
        setIsLoading(false)
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            getCollectionVolume().then((res) => parseCollectionVolume(res))
        }
    }, [])

    const firstFive = collectionVolumes?.slice(0, 5)
    const lastFive = collectionVolumes?.slice(5, 10)

    return (
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-0 xl:gap-32 lg:gap-8 px-4">
            <div>
                {!isLoading
                    ? collectionVolumes &&
                      firstFive?.map((volume, index) => (
                          <Link
                              href={`/collection/${volume?.collection?.name}`}
                          >
                              <div className="flex items-center w-full gap-2 mt-3 ">
                                  <div
                                      className={`flex items-center text-[14px] lg:text-[16px] font-medium ${
                                          index + 1 <= 3
                                              ? 'text-[#F6C30D]'
                                              : 'dark:!text-white text-black'
                                      }`}
                                  >
                                      {index + 1}{' '}
                                  </div>
                                  <div className="mx-4">
                                      <PreviewGraphic
                                          hash={volume.collection.image}
                                          collection={volume.collection.name}
                                          size={240}
                                      />
                                  </div>
                                  <div className="flex flex-col w-full gap-1">
                                      <div className="grid grid-cols-2 text-sm ">
                                          <div className="font-medium xl:text-[18px] text-[16px] truncate ">
                                              {volume?.collection?.displayName}
                                          </div>

                                          <div className="flex items-center gap-2 justify-end xl:text-[18px] text-[16px] font-medium">
                                              <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="11"
                                                  height="7"
                                                  viewBox="0 0 11 7"
                                                  fill="none"
                                              >
                                                  <path
                                                      d={
                                                          volume?.stats
                                                              ?.change > 0
                                                              ? 'M5.96131 0.78125L11 6.78125L0.922615 6.78125L5.96131 0.78125Z' // Upward orientation for positive change
                                                              : 'M5.03869 6.21875L0 0.21875L10.0774 0.21875L5.03869 6.21875Z'
                                                      } // Downward orientation for negative change
                                                      fill={
                                                          volume?.stats
                                                              ?.change > 0
                                                              ? '#34D399'
                                                              : '#EF4444'
                                                      }
                                                  />
                                              </svg>
                                              {volume?.stats?.change.toFixed(2)}
                                              %
                                          </div>
                                      </div>
                                      <div className="grid grid-cols-2 ">
                                          <div className="font-medium flex justify-start text-[14px]   text-[#9299A4]">
                                              {volume?.stats?.waxVolume.toFixed(
                                                  2,
                                              )}{' '}
                                              {''}
                                              WAX ${'('}
                                              {volume?.stats?.usdVolume.toFixed(
                                                  2,
                                              )}
                                              {')'}
                                          </div>

                                          <div className="flex justify-end text-[14px] font-medium  ">
                                              Sales {volume?.stats?.sales}
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </Link>
                      ))
                    : Array.from(new Array(5)).map(() => (
                          <Skeleton className="w-full h-[85px] rounded-lg mb-2">
                              <div className="h-24 rounded-lg bg-default-300"></div>
                          </Skeleton>
                      ))}
            </div>
            <div>
                {!isLoading
                    ? collectionVolumes &&
                      lastFive?.map((volume, index) => (
                          <Link
                              href={`/collection/${volume?.collection?.name}`}
                          >
                              <div className="flex items-center w-full gap-2 mt-3 ">
                                  <div className="flex items-center text-[14px] lg:text-[16px] font-medium dark:!text-white text-black">
                                      {5 + index + 1}{' '}
                                  </div>
                                  <div className="mx-4">
                                      <PreviewGraphic
                                          hash={volume.collection.image}
                                          collection={volume.collection.name}
                                          size={240}
                                      />
                                  </div>
                                  <div className="flex flex-col w-full gap-1">
                                      <div className="grid grid-cols-2 text-sm ">
                                          <div className="font-medium xl:text-[18px] text-[16px] truncate ">
                                              {volume?.collection?.displayName}
                                          </div>

                                          <div className="flex items-center gap-2 justify-end xl:text-[18px] text-[16px] font-medium">
                                              <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="11"
                                                  height="7"
                                                  viewBox="0 0 11 7"
                                                  fill="none"
                                              >
                                                  <path
                                                      d={
                                                          volume?.stats
                                                              ?.change > 0
                                                              ? 'M5.96131 0.78125L11 6.78125L0.922615 6.78125L5.96131 0.78125Z' // Upward orientation for positive change
                                                              : 'M5.03869 6.21875L0 0.21875L10.0774 0.21875L5.03869 6.21875Z'
                                                      } // Downward orientation for negative change
                                                      fill={
                                                          volume?.stats
                                                              ?.change > 0
                                                              ? '#34D399'
                                                              : '#EF4444'
                                                      }
                                                  />
                                              </svg>
                                              {volume?.stats?.change.toFixed(2)}
                                              %
                                          </div>
                                      </div>
                                      <div className="grid grid-cols-2 ">
                                          <div className="font-medium flex justify-start text-[14px]   text-[#9299A4]">
                                              {volume?.stats?.waxVolume.toFixed(
                                                  2,
                                              )}{' '}
                                              {''}
                                              WAX ${'('}
                                              {volume?.stats?.usdVolume.toFixed(
                                                  2,
                                              )}
                                              {')'}
                                          </div>

                                          <div className="flex justify-end text-[14px] font-medium  ">
                                              Sales {volume?.stats?.sales}
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </Link>
                      ))
                    : Array.from(new Array(5)).map(() => (
                          <Skeleton className="w-full h-[85px] rounded-lg mb-2">
                              <div className="h-24 rounded-lg bg-default-300"></div>
                          </Skeleton>
                      ))}
            </div>
        </div>
    )
}

export default CollectionRankingsHome
